import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 8px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.onSurfaceVariant};
`;

export const LockedState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 80px 24px;
  text-align: center;
  color: ${colors.onSurfaceVariant};

  h2 {
    color: ${colors.onSurface};
    font-size: 18px;
    font-weight: 800;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Row = styled.tr`
  cursor: pointer;

  &:hover {
    background-color: ${colors.surfaceContainerLow};
  }
`;

export const StudentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StudentAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const StudentName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const RequestedBadge = styled.span`
  display: inline-flex;
  padding: 6px 14px;
  border-radius: ${radius.full};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;

  background-color: ${colors.surfaceContainerHighest};
  color: ${colors.onSurfaceVariant};
`;
